module.exports = __webpack_public_path__ + "static/media/smsAlertNoBadge.bc545738.png";